export default function activeAuditDirective() {
  return {
    template: require('./active-audit.html'),
    scope: {
      audit: '='
    },
    controller: 'ActiveAuditController',
    controllerAs: 'activeAuditVM',
    bindToController: true,
    replace: true
  };
}
